export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto mb-8">
            有任何问题或建议，欢迎通过以下方式联系我们
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="rounded-xl bg-white border border-background-200/70 p-6">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">意见反馈</h3>
              <p className="text-xs text-foreground-500">
                如对平台有任何建议或发现片源问题，欢迎通过意见反馈告知我们。
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-1 mt-3 text-xs text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                提交反馈
                <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
            <div className="rounded-xl bg-white border border-background-200/70 p-6">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-film-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">资源投稿</h3>
              <p className="text-xs text-foreground-500">
                如果您有优质影视资源希望收录，欢迎向我们投稿，共同丰富平台内容。
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-1 mt-3 text-xs text-accent-500 font-medium hover:text-accent-600 transition-colors whitespace-nowrap"
              >
                投稿资源
                <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
            <div className="rounded-xl bg-white border border-background-200/70 p-6">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">商务合作</h3>
              <p className="text-xs text-foreground-500">
                商务合作、品牌推广等事宜，请通过合作渠道联系我们沟通洽谈。
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-1 mt-3 text-xs text-secondary-500 font-medium hover:text-secondary-600 transition-colors whitespace-nowrap"
              >
                商务联系
                <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}